import React from 'react';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const SpecializationForm = ({ formData, onChange, errors }) => {
  const travelCategories = [
    { id: 'beach', label: 'Beach', description: 'Coastal destinations and resort experiences' },
    { id: 'city_break', label: 'City Break', description: 'Urban exploration and cultural experiences' },
    { id: 'family', label: 'Family', description: 'Child-friendly destinations and activities' },
    { id: 'couples_romantic', label: 'Couples / Romantic Getaway', description: 'Romantic getaways and couples experiences' },
    { id: 'honeymoon', label: 'Honeymoon', description: 'Special honeymoon experiences' },
    { id: 'short_break', label: 'Short Break / Weekend Away', description: 'Quick getaways and weekend trips' },
    { id: 'all_inclusive', label: 'All-Inclusive Resort', description: 'All-inclusive resort experiences' },
    { id: 'luxury', label: 'Luxury', description: 'Premium accommodations and exclusive experiences' },
    { id: 'golf', label: 'Golf', description: 'Golf holidays and courses' },
    { id: 'ski_snow', label: 'Ski / Snow', description: 'Mountain resorts and winter activities' },
    { id: 'cruise', label: 'Cruise', description: 'Ocean and river cruise experiences' },
    { id: 'adventure', label: 'Adventure', description: 'Outdoor activities and adventure travel' },
    { id: 'wellness_spa', label: 'Wellness & Spa Retreat', description: 'Health retreats and spa experiences' },
    { id: 'safari_wildlife', label: 'Safari / Wildlife', description: 'Nature reserves and wildlife experiences' },
    { id: 'food_wine', label: 'Food & Wine', description: 'Culinary tours and gastronomic experiences' },
    { id: 'multi_centre', label: 'Multi-Centre', description: 'Multi-destination travel experiences' },
    { id: 'cultural_heritage', label: 'Cultural & Heritage', description: 'Historical sites and cultural immersion' },
    { id: 'group', label: 'Group', description: 'Large group coordination and planning' }
  ];

  const continents = [
    { value: 'europe', label: 'Europe' },
    { value: 'asia', label: 'Asia' },
    { value: 'north_america', label: 'North America' },
    { value: 'south_america', label: 'South America' },
    { value: 'africa', label: 'Africa' },
    { value: 'oceania', label: 'Oceania' },
    { value: 'antarctica', label: 'Antarctica' }
  ];

  // Added comprehensive countries list
  const countries = [
    // Europe
    { value: 'united_kingdom', label: 'United Kingdom', continent: 'europe' },
    { value: 'france', label: 'France', continent: 'europe' },
    { value: 'germany', label: 'Germany', continent: 'europe' },
    { value: 'italy', label: 'Italy', continent: 'europe' },
    { value: 'spain', label: 'Spain', continent: 'europe' },
    { value: 'portugal', label: 'Portugal', continent: 'europe' },
    { value: 'netherlands', label: 'Netherlands', continent: 'europe' },
    { value: 'belgium', label: 'Belgium', continent: 'europe' },
    { value: 'switzerland', label: 'Switzerland', continent: 'europe' },
    { value: 'austria', label: 'Austria', continent: 'europe' },
    { value: 'greece', label: 'Greece', continent: 'europe' },
    { value: 'croatia', label: 'Croatia', continent: 'europe' },
    { value: 'iceland', label: 'Iceland', continent: 'europe' },
    { value: 'norway', label: 'Norway', continent: 'europe' },
    { value: 'sweden', label: 'Sweden', continent: 'europe' },
    { value: 'denmark', label: 'Denmark', continent: 'europe' },
    { value: 'finland', label: 'Finland', continent: 'europe' },
    { value: 'poland', label: 'Poland', continent: 'europe' },
    { value: 'czech_republic', label: 'Czech Republic', continent: 'europe' },
    { value: 'hungary', label: 'Hungary', continent: 'europe' },
    
    // Asia
    { value: 'japan', label: 'Japan', continent: 'asia' },
    { value: 'china', label: 'China', continent: 'asia' },
    { value: 'india', label: 'India', continent: 'asia' },
    { value: 'thailand', label: 'Thailand', continent: 'asia' },
    { value: 'vietnam', label: 'Vietnam', continent: 'asia' },
    { value: 'singapore', label: 'Singapore', continent: 'asia' },
    { value: 'malaysia', label: 'Malaysia', continent: 'asia' },
    { value: 'indonesia', label: 'Indonesia', continent: 'asia' },
    { value: 'philippines', label: 'Philippines', continent: 'asia' },
    { value: 'south_korea', label: 'South Korea', continent: 'asia' },
    { value: 'cambodia', label: 'Cambodia', continent: 'asia' },
    { value: 'laos', label: 'Laos', continent: 'asia' },
    { value: 'myanmar', label: 'Myanmar', continent: 'asia' },
    { value: 'sri_lanka', label: 'Sri Lanka', continent: 'asia' },
    { value: 'maldives', label: 'Maldives', continent: 'asia' },
    { value: 'nepal', label: 'Nepal', continent: 'asia' },
    { value: 'bhutan', label: 'Bhutan', continent: 'asia' },
    
    // North America
    { value: 'united_states', label: 'United States', continent: 'north_america' },
    { value: 'canada', label: 'Canada', continent: 'north_america' },
    { value: 'mexico', label: 'Mexico', continent: 'north_america' },
    { value: 'costa_rica', label: 'Costa Rica', continent: 'north_america' },
    { value: 'panama', label: 'Panama', continent: 'north_america' },
    { value: 'guatemala', label: 'Guatemala', continent: 'north_america' },
    { value: 'belize', label: 'Belize', continent: 'north_america' },
    { value: 'cuba', label: 'Cuba', continent: 'north_america' },
    { value: 'jamaica', label: 'Jamaica', continent: 'north_america' },
    { value: 'bahamas', label: 'Bahamas', continent: 'north_america' },
    
    // South America
    { value: 'brazil', label: 'Brazil', continent: 'south_america' },
    { value: 'argentina', label: 'Argentina', continent: 'south_america' },
    { value: 'chile', label: 'Chile', continent: 'south_america' },
    { value: 'peru', label: 'Peru', continent: 'south_america' },
    { value: 'ecuador', label: 'Ecuador', continent: 'south_america' },
    { value: 'colombia', label: 'Colombia', continent: 'south_america' },
    { value: 'bolivia', label: 'Bolivia', continent: 'south_america' },
    { value: 'uruguay', label: 'Uruguay', continent: 'south_america' },
    { value: 'paraguay', label: 'Paraguay', continent: 'south_america' },
    { value: 'venezuela', label: 'Venezuela', continent: 'south_america' },
    
    // Africa
    { value: 'south_africa', label: 'South Africa', continent: 'africa' },
    { value: 'kenya', label: 'Kenya', continent: 'africa' },
    { value: 'tanzania', label: 'Tanzania', continent: 'africa' },
    { value: 'egypt', label: 'Egypt', continent: 'africa' },
    { value: 'morocco', label: 'Morocco', continent: 'africa' },
    { value: 'tunisia', label: 'Tunisia', continent: 'africa' },
    { value: 'botswana', label: 'Botswana', continent: 'africa' },
    { value: 'namibia', label: 'Namibia', continent: 'africa' },
    { value: 'zimbabwe', label: 'Zimbabwe', continent: 'africa' },
    { value: 'zambia', label: 'Zambia', continent: 'africa' },
    { value: 'madagascar', label: 'Madagascar', continent: 'africa' },
    { value: 'mauritius', label: 'Mauritius', continent: 'africa' },
    
    // Oceania
    { value: 'australia', label: 'Australia', continent: 'oceania' },
    { value: 'new_zealand', label: 'New Zealand', continent: 'oceania' },
    { value: 'fiji', label: 'Fiji', continent: 'oceania' },
    { value: 'samoa', label: 'Samoa', continent: 'oceania' },
    { value: 'tonga', label: 'Tonga', continent: 'oceania' },
    { value: 'vanuatu', label: 'Vanuatu', continent: 'oceania' },
    { value: 'papua_new_guinea', label: 'Papua New Guinea', continent: 'oceania' },
    { value: 'cook_islands', label: 'Cook Islands', continent: 'oceania' },
    { value: 'french_polynesia', label: 'French Polynesia', continent: 'oceania' }
  ];

  const accommodationStandards = [
    { id: 'budget', label: 'Budget', description: 'Hostels, guesthouses, budget hotels' },
    { id: 'three_star', label: '3-Star', description: 'Mid-range hotels with standard amenities' },
    { id: 'four_star', label: '4-Star', description: 'Superior hotels with enhanced services' },
    { id: 'five_star', label: '5-Star', description: 'Luxury hotels and premium resorts' }
  ];

  const handleCategoryChange = (categoryId, checked) => {
    const currentCategories = formData?.travelCategories || [];
    let updatedCategories;
    
    if (checked) {
      updatedCategories = [...currentCategories, categoryId];
    } else {
      updatedCategories = currentCategories?.filter(id => id !== categoryId);
    }
    
    onChange({ target: { name: 'travelCategories', value: updatedCategories } });
  };

  const handleAccommodationChange = (standardId, checked) => {
    const currentStandards = formData?.accommodationStandards || [];
    let updatedStandards;
    
    if (checked) {
      updatedStandards = [...currentStandards, standardId];
    } else {
      updatedStandards = currentStandards?.filter(id => id !== standardId);
    }
    
    onChange({ target: { name: 'accommodationStandards', value: updatedStandards } });
  };

  return (
    <div className="space-y-6">
      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Travel Specializations</h3>
        <p className="text-sm text-muted-foreground mb-6">
          Select the types of travel you specialize in. Choose at least 3 categories to maximize your enquiry matches.
        </p>
        
        <CheckboxGroup 
          label="Travel Categories" 
          error={errors?.travelCategories}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {travelCategories?.map(category => (
            <div key={category?.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-colors">
              <Checkbox
                label={category?.label}
                description={category?.description}
                checked={(formData?.travelCategories || [])?.includes(category?.id)}
                onChange={(e) => handleCategoryChange(category?.id, e?.target?.checked)}
                className="mb-0"
              />
            </div>
          ))}
        </CheckboxGroup>
      </div>
      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Destination Expertise</h3>
        <p className="text-sm text-muted-foreground mb-6">
          Select the continents where you have expertise and can provide specialized knowledge.
        </p>
        
        <Select
          label="Destination Continents"
          options={continents}
          value={formData?.destinationContinents}
          onChange={(value) => onChange({ target: { name: 'destinationContinents', value } })}
          error={errors?.destinationContinents}
          placeholder="Select continents you specialize in"
          multiple
          searchable
          required
        />
      </div>

      {/* New Countries Section */}
      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Specific Country Expertise</h3>
        <p className="text-sm text-muted-foreground mb-6">
          Optional: Select specific countries where you have in-depth local knowledge and connections. 
          This helps customers find agents with specialized expertise in their preferred destinations.
        </p>
        
        <Select
          label="Destination Countries (Optional)"
          options={countries}
          value={formData?.destinationCountries}
          onChange={(value) => onChange({ target: { name: 'destinationCountries', value } })}
          error={errors?.destinationCountries}
          placeholder="Search and select specific countries"
          multiple
          searchable
          className="mb-4"
        />
        
        <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <div className="w-4 h-4 bg-accent rounded-full flex items-center justify-center">
              <span className="text-xs text-accent-foreground font-bold">i</span>
            </div>
            <h4 className="text-sm font-medium text-foreground">Why specify countries?</h4>
          </div>
          <p className="text-xs text-muted-foreground">
            Agents with country-specific expertise receive priority for enquiries to those destinations. 
            This includes local contacts, cultural knowledge, hidden gems, and current travel conditions.
          </p>
        </div>
      </div>

      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Accommodation Standards</h3>
        <p className="text-sm text-muted-foreground mb-6">
          Select the accommodation standards you work with to match customer preferences.
        </p>
        
        <CheckboxGroup 
          label="Accommodation Types" 
          error={errors?.accommodationStandards}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          {accommodationStandards?.map(standard => (
            <div key={standard?.id} className="border border-border rounded-lg p-4 hover:bg-muted/50 transition-colors">
              <Checkbox
                label={standard?.label}
                description={standard?.description}
                checked={(formData?.accommodationStandards || [])?.includes(standard?.id)}
                onChange={(e) => handleAccommodationChange(standard?.id, e?.target?.checked)}
                className="mb-0"
              />
            </div>
          ))}
        </CheckboxGroup>
      </div>
    </div>
  );
};

export default SpecializationForm;